import config from '../../config'

var maps

// this implementation assumes the script is loaded before the maps API is used
// this is bad practice but it works and avoid using promises
if (!window.google || !window.google.maps) {
    maps = {}

    var url = '//maps.googleapis.com/maps/api/js?libraries=places,geometry'
    if (config.google.apiKey) {
        url += '&key=' + config.google.apiKey
    }

    // load script
    var script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = url
    script.defer = true
    script.async = true
    script.onload = () => {
        Object.assign(maps, window.google.maps)
    }
    document.body.appendChild(script)
} else {
    maps = window.google.maps
}

export default maps


// WEBPACK FOOTER //
// ./lib/core/google/maps.js